import type { ReactNode } from "react";

import type { PaletteSubPath } from "metabase/palette/types";

export type AiControlsPlugin = {
  isEnabled: boolean;
  getAiControlsRoutes: () => ReactNode;
  getAiControlsNavItems: () => ReactNode;
  getAiControlsPaths: () => PaletteSubPath[];
};

const getDefaultPluginAiControls = (): AiControlsPlugin => ({
  isEnabled: false,
  getAiControlsRoutes: () => null,
  getAiControlsNavItems: () => null,
  getAiControlsPaths: () => [],
});

export const PLUGIN_AI_CONTROLS = getDefaultPluginAiControls();

/**
 * @internal Do not call directly. Use the main reinitialize function from metabase/plugins instead.
 */
export function reinitialize() {
  Object.assign(PLUGIN_AI_CONTROLS, getDefaultPluginAiControls());
}
